var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _rect, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvgexport2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 301,
    height: 161,
    viewBox: "0 0 301 161",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M210.957 125.991L124.606 150.295C122.693 150.765 120.696 149.942 119.67 148.26L54.188 30.4095C53.4296 29.2135 53.7847 27.6297 54.9799 26.872C55.241 26.7063 55.5302 26.5895 55.8329 26.5264L142.184 2.22207C144.094 1.74961 146.089 2.57038 147.114 4.25084L212.585 122.102C213.345 123.3 212.991 124.888 211.793 125.648C211.536 125.811 211.254 125.927 210.957 125.991Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M206.875 121.626L123.39 145.128L58.8145 28.9162L142.299 5.41992L206.875 121.626Z",
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.572 30.0325L124.054 28.207",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6133 42.6868L112.554 31.4443",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110.461 37.2508L126.563 32.7168",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7891 44.1968L106.07 38.4883",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1211 47.1964L82.0208 45.2549",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7051 46.0632L129.078 37.2334",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6289 51.7144L90.8015 48.0059",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M146.641 26.6316C144.947 23.8619 141.658 22.5042 138.503 23.272C135.498 24.1209 134.284 26.992 135.783 29.6952C137.473 32.4689 140.766 33.8286 143.921 33.0548C146.897 32.2119 148.141 29.3341 146.641 26.6316Z",
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2804 60.9854L83.7988 62.8108",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M135.236 48.332L95.2949 59.5745",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M102.406 62.7939L86.3047 67.328",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M127.082 55.8467L106.801 61.5552",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M137.747 52.8457L130.848 54.7872",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M120.184 63.0078L88.8164 71.8376",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M140.26 57.3574L127.082 61.066",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M157.825 46.7601C156.134 43.9864 152.842 42.6267 149.687 43.4005C146.682 44.2435 145.467 47.1205 146.966 49.7949C148.656 52.5706 151.949 53.9303 155.104 53.1545C158.104 52.3344 159.325 49.4573 157.825 46.7601Z",
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M139.938 70.2805L146.419 68.4551",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9844 82.9349L134.925 71.6924",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M132.832 77.5047L148.934 72.9707",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M108.154 84.4528L128.435 78.7383",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4883 87.4513L104.388 85.5098",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M120.072 86.3118L151.439 77.4873",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M100 91.9683L113.173 88.2598",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M165.367 63.8128C162.161 62.5524 158.754 63.5846 157.758 66.1183C156.762 68.652 158.553 71.7278 161.759 72.9883C164.965 74.2487 168.372 73.2165 169.368 70.6828C170.364 68.1491 168.573 65.0733 165.367 63.8128Z",
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M112.65 101.24L106.168 103.065",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M157.607 88.585L117.666 99.8274",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M124.773 103.048L108.672 107.577",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M149.45 96.1006L129.168 101.808",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M160.118 93.0967L153.219 95.0382",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M142.55 103.263L111.184 112.093",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M162.621 97.6123L149.449 101.321",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M180.188 87.0083C178.496 84.2359 175.205 82.8769 172.05 83.6487C169.045 84.4977 167.83 87.3687 169.33 90.0719C171.02 92.8456 174.313 94.2053 177.468 93.4315C180.473 92.606 181.694 89.6994 180.188 87.0083Z",
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M162.309 110.534L168.79 108.709",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M117.352 123.189L157.292 111.946",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M155.197 117.754L171.299 113.226",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M130.525 124.702L150.806 118.993",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M119.855 127.706L126.756 125.759",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M142.438 126.566L173.804 117.736",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M122.365 132.216L135.538 128.508",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M187.734 104.06C184.528 102.799 181.121 103.832 180.125 106.365C179.129 108.899 180.921 111.975 184.127 113.235C187.333 114.496 190.739 113.464 191.735 110.93C192.731 108.396 190.94 105.32 187.734 104.06Z",
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M114.035 7.39061L103.06 10.4771C102.229 10.512 101.317 10.4482 101.06 10.0234C100.479 8.93082 101.223 7.90737 101.455 6.94231C101.725 5.83028 101.551 4.65718 100.973 3.6693C99.2348 0.819083 95.8497 -0.575489 92.6082 0.222464C89.5271 1.09424 88.2836 4.04176 89.8177 6.80876C90.5707 8.08656 91.6989 9.10195 93.0498 9.71535C93.0498 9.71535 95.2759 10.7093 95.7235 11.5112C95.9618 11.9354 95.3397 12.4354 94.7061 12.8132L82.8771 16.1439C81.3503 16.4647 80.3725 17.9626 80.694 19.4901C80.7631 19.8189 80.8906 20.1324 81.0698 20.4169L82.6684 23.2886L121.074 12.4823L119.476 9.60462C118.342 7.75637 116.138 6.85909 114.035 7.39061ZM94.486 3.63507C95.5249 3.37803 96.6101 3.825 97.1657 4.73972C97.5765 5.38802 97.3832 6.24637 96.7349 6.65642C96.5926 6.74635 96.4349 6.8101 96.2705 6.84366C95.235 7.10137 94.1518 6.65642 93.5968 5.74505C93.1854 5.09407 93.3793 4.23236 94.0303 3.8203C94.1699 3.73238 94.3243 3.6693 94.486 3.63507Z",
    fill: "#FF924E"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M137.721 26.969L142.458 30.2762L147.341 19.3311",
    stroke: "#FF924E",
    strokeWidth: "3.43654px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M148.73 46.7834L153.468 50.0853L158.351 39.1455",
    stroke: "#FF924E",
    strokeWidth: "3.43654px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M226.429 44.0764C226.429 44.0764 227.691 41.3906 226.901 39.333C226.11 37.2754 211.56 33.9561 211.56 33.9561C211.56 33.9561 208.241 33.9561 208.398 35.8566C208.555 37.7572 220.576 45.0294 221.524 45.6576C222.471 46.2857 226.109 47.7152 226.429 44.0764Z",
    fill: "#F7D1B9"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M212.764 31.2996C211.868 30.968 210.989 30.5915 210.131 30.1721C208.875 29.5446 210.253 32.4331 210.758 32.5552C211.264 32.6774 212.502 32.9331 212.502 32.9331L212.764 31.2996Z",
    fill: "#F7D1B9"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M169.342 59.4147L162.07 68.268L162.698 69.5351L172.981 67.0298L245.358 24.8974C248.348 23.1478 249.353 19.3057 247.604 16.3165C247.577 16.2702 247.549 16.2239 247.52 16.1783C245.685 13.2442 241.819 12.3536 238.885 14.1891C238.856 14.2066 238.829 14.224 238.801 14.2421L169.342 59.4147Z",
    fill: "#FF924E"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M205.708 43.0059L203.348 44.5293",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M226.023 29.9395L208.59 41.1584",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M162.744 68.083C162.744 68.083 160.936 68.8387 161.215 69.6004C161.494 70.3621 164.087 68.5192 164.087 68.5192L162.744 68.083Z",
    fill: "#FF924E",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M162.07 68.2693L162.698 69.5363L172.981 67.0311C167.284 64.8164 169.342 59.4395 169.342 59.4395L162.07 68.2693Z",
    fill: "#333333"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M247.52 16.1383C245.684 13.2041 241.818 12.3136 238.884 14.1491C238.855 14.1665 238.828 14.184 238.8 14.2021L226.175 22.4219C225.835 23.2883 225.661 24.2117 225.663 25.1426C225.589 29.0276 228.667 32.2436 232.552 32.3389L245.381 24.8748C248.368 23.1205 249.366 19.2764 247.612 16.2899C247.582 16.2396 247.551 16.1886 247.52 16.1383Z",
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M247.52 16.1383C245.685 13.2041 241.819 12.3136 238.885 14.1491C238.856 14.1665 238.829 14.184 238.801 14.2021L229.21 20.4508C228.746 21.4072 228.506 22.4568 228.507 23.5198C228.455 27.3203 231.494 30.4437 235.295 30.4954C235.299 30.4954 235.304 30.4954 235.308 30.4954C235.465 30.4954 235.627 30.4954 235.779 30.4954L245.382 24.909C248.373 23.1635 249.384 19.3227 247.639 16.3309C247.6 16.2664 247.561 16.202 247.52 16.1383Z",
    fill: "#333333"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M204.736 34.1875C204.736 34.1875 203.329 34.1875 203.329 34.8271C203.329 35.4666 202.957 37.7337 203.771 37.6699C204.584 37.6061 204.515 36.182 204.585 35.6821C204.654 35.1821 204.736 34.1875 204.736 34.1875Z",
    fill: "#F7D1B9"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M206.27 31.8734C206.27 31.8734 205.015 31.4841 204.724 32.2573C204.434 33.0304 204.143 36.704 205.015 36.6054C205.887 36.5067 206.078 33.2277 206.27 31.8734Z",
    fill: "#F7D1B9"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M208.208 32.0659C208.208 32.0659 206.755 30.8102 206.273 31.874C205.79 32.9377 205.692 35.9429 206.273 35.9429C206.854 35.9429 207.726 34.6873 207.918 34.0128C208.062 33.3725 208.159 32.7216 208.208 32.0659Z",
    fill: "#F7D1B9"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M210.256 32.6485C210.256 32.6485 208.419 31.1022 208.128 31.3928C207.838 31.6834 206.675 34.6598 207.547 35.2584C208.419 35.8571 209.524 33.1833 209.524 33.1833L210.256 32.6485Z",
    fill: "#F7D1B9"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M183.708 41.8207C183.708 41.8207 183.912 44.9192 184.737 45.6453C185.237 46.0775 185.687 46.5627 186.08 47.0929C186.194 47.8808 186.264 48.6747 186.29 49.4707C186.29 50.4008 186.912 50.2961 187.452 50.2961C187.992 50.2961 188.899 52.0397 189.417 52.8772C190.403 54.0953 191.581 55.1436 192.905 55.9811C193.835 56.4986 195.387 54.5335 195.387 54.5335L196.108 56.6033L203.45 51.8484L199.834 44.8145C199.621 42.3763 198.878 40.014 197.66 37.8913C195.59 34.1713 192.801 32.0781 188.151 33.4445C183.5 34.8102 183.708 41.8207 183.708 41.8207Z",
    fill: "#F7D1B9"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M192.203 28.0431C190.469 28.1189 188.758 28.4618 187.128 29.0605C184.414 30.0195 183.745 33.7978 181.38 35.1521C179.014 36.5064 180.025 33.9898 178.839 34.6408C177.654 35.2917 176.474 41.2385 179.008 42.9297C181.542 44.6215 185.269 42.4236 185.269 42.4236C185.269 42.4236 184.932 43.586 185.943 43.9464C186.555 44.1491 187.178 44.3182 187.809 44.4524C187.809 44.4524 187.634 46.4872 189.157 46.3127C190.68 46.1383 189.332 43.7786 189.332 43.7786C189.332 43.7786 192.209 49.3589 194.412 50.0394C196.615 50.7193 199.824 47.6677 200.667 46.3134C201.51 44.9591 200.835 35.3213 198.975 31.6006C197.114 27.88 192.203 28.0431 192.203 28.0431Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M189.394 47.4013C189.394 47.4013 188.36 43.4719 190.011 43.9893C191.661 44.5068 192.597 48.0234 192.493 48.4361C192.388 48.8489 191.563 49.0522 191.15 48.9536",
    fill: "#F7D1B9"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M201.341 48.8253C199.414 49.9085 197.572 51.1366 195.831 52.499C194.087 54.0512 192.523 58.7014 192.523 58.7014C192.523 58.7014 203.173 51.4641 205.033 50.4353C206.893 49.4065 207.306 48.883 207.306 48.883C207.306 48.883 203.411 48.3078 201.341 48.8253Z",
    fill: "#B2B2B2",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M215.674 42.4953C216.584 40.884 218.134 39.735 219.941 39.3331C222.946 38.6995 226.916 40.7572 227.375 44.0765C227.834 47.3958 225.318 48.9823 223.737 48.9823C222.155 48.9823 220.731 46.7676 220.731 46.7676C220.731 46.7676 215.674 44.867 215.674 42.4953Z",
    fill: "#999999"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M173.293 77.7619L178.356 64.3168C177.79 64.8235 177.058 65.1047 176.299 65.1074C175.032 65.1074 172.032 64.6363 172.811 64.1598C173.59 63.6833 176.601 61.631 176.601 61.631C176.601 61.631 174.392 62.1075 173.758 61.631C173.124 61.1545 172.81 60.521 173.281 60.364C173.752 60.2069 174.705 60.364 176.444 59.7304C178.182 59.0969 178.972 58.4688 180.396 58.4688C181.821 58.4688 183.088 60.9975 183.088 61.7881C183.088 62.5786 181.978 77.5995 181.978 78.233C181.978 78.8665 181.978 79.5001 177.868 79.9766C173.758 80.453 173.136 79.5001 173.293 77.7619Z",
    fill: "#F7D1B9"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M178.193 74.4385C178.193 74.4385 173.135 75.8626 172.188 78.0773C171.241 80.2919 171.398 83.6112 173.293 85.5118C175.188 87.4124 175.984 87.8835 178.036 87.093C180.089 86.3024 180.57 85.0353 180.727 83.7683C180.884 82.5005 181.988 78.2343 178.193 74.4385Z",
    fill: "#999999"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M176.144 141.488C176.144 141.488 171.715 139.43 169.977 140.221C168.239 141.011 168.233 141.802 170.448 145.284C172.663 148.765 178.83 153.032 180.911 152.079C182.992 151.126 181.068 144.807 181.068 144.807L176.144 141.488Z",
    fill: "#5153A0",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M172.98 146.387C171.444 144.686 170.152 142.778 169.144 140.72C168.33 141.441 168.678 142.498 170.446 145.283C172.66 148.77 178.828 153.031 180.909 152.078C181.446 151.733 181.772 151.14 181.775 150.503C178.869 151.729 175.863 149.573 172.98 146.387Z",
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M198.91 93.0967L199.067 97.8462C199.067 97.8462 189.424 101.48 184.68 104.822C179.937 108.164 176.774 110.67 176.298 113.832C175.821 116.994 176.141 141.507 176.141 141.507C176.141 141.507 174.717 141.821 175.193 142.769C175.67 143.717 176.611 147.198 177.879 147.513C179.146 147.827 180.727 148.466 181.041 147.676C181.355 146.885 182.308 142.142 182.942 140.56C183.575 138.979 184.68 131.556 185.628 126.325C186.183 123.404 186.499 120.444 186.575 117.472C189.914 117.006 193.199 116.212 196.382 115.1C201.916 113.199 209.978 109.723 209.978 109.723C209.978 109.723 216.465 125.999 217.889 129.173C219.314 132.347 224.865 139.45 225.952 141.508C227.039 143.566 234.015 152.419 234.015 152.419C234.015 152.419 236.706 150.047 238.444 150.047H240.816C240.816 150.047 237.968 142.142 235.585 137.393C233.202 132.644 228.312 124.901 228.312 124.901C228.312 124.901 223.889 97.2368 223.726 95.3302C223.418 91.68 221.081 86.1688 221.081 86.1688C221.081 86.1688 213.46 84.5575 198.91 93.0967Z",
    fill: "#333333"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M234.017 152.401C233.611 153.064 233.242 153.748 232.912 154.453C232.755 154.929 229.273 155.407 229.75 156.987C230.226 158.568 233.86 159.83 235.598 159.992C237.336 160.155 240.829 157.778 241.451 157.144C241.823 156.772 242.381 154.313 242.085 152.401C241.892 151.507 241.453 150.686 240.818 150.029C240.818 150.029 237.813 145.443 234.017 152.401Z",
    fill: "#5153A0",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M242.082 152.4C241.92 151.597 241.549 150.851 241.007 150.237C239.684 150.248 238.423 150.8 237.519 151.766C235.938 153.661 236.729 157.934 234.828 158.567C233.415 159.038 230.945 157.312 229.783 156.405C229.718 156.593 229.718 156.797 229.783 156.986C230.254 158.567 233.893 159.829 235.631 159.991C237.369 160.154 240.862 157.777 241.484 157.143C241.82 156.771 242.378 154.312 242.082 152.4Z",
    fill: "#FFFFFF",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M237.969 153.505C237.342 156.354 238.132 158.249 235.598 159.992C237.341 160.149 240.829 157.778 241.451 157.144C241.823 156.772 242.381 154.313 242.085 152.401C242.017 152.004 241.885 151.622 241.695 151.267H241.451C241.452 151.268 238.603 150.663 237.969 153.505Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M211.559 109.384L220.888 104.804",
    stroke: "#FFFFFF",
    strokeWidth: "0.572757px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M215.836 107.333L223.898 106.223",
    stroke: "#FFFFFF",
    strokeWidth: "0.572757px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M218.979 41.3905C216.293 41.7046 209.335 46.448 208.859 46.9245C208.382 47.401 206.487 48.5056 205.696 49.1392C205.696 49.1392 189.42 59.2595 187.984 60.1837C186.549 61.1078 183.717 63.0319 183.874 63.6714C184.031 64.311 175.492 78.2037 175.492 78.2037C175.492 78.2037 172.963 81.5284 175.335 84.5283C177.707 87.5275 179.922 85.4819 181.026 84.8477C182.131 84.2142 190.833 75.989 190.833 75.989L198.854 95.1714C198.854 95.1714 209.963 87.7248 221.827 88.1959L213.916 57.2012C213.916 57.2012 224.833 48.9815 225.146 46.1567C225.46 43.332 221.682 41.0711 218.979 41.3905Z",
    fill: "#B3B3B3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 174.232,
    y: 40.9434,
    width: 51.0045,
    height: 54.3601,
    fill: "url(\"#pattern0\")"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M218.979 41.3905C216.293 41.7046 209.335 46.448 208.859 46.9245C208.382 47.401 206.487 48.5056 205.696 49.1392C205.696 49.1392 189.42 59.2595 187.984 60.1837C186.549 61.1078 183.717 63.0319 183.874 63.6714C184.031 64.311 175.492 78.2037 175.492 78.2037C175.492 78.2037 172.963 81.5284 175.335 84.5283C177.707 87.5275 179.922 85.4819 181.026 84.8477C182.131 84.2142 190.833 75.989 190.833 75.989L198.854 95.1714C198.854 95.1714 209.963 87.7248 221.827 88.1959L213.916 57.2012C213.916 57.2012 224.833 48.9815 225.146 46.1567C225.46 43.332 221.682 41.0711 218.979 41.3905Z",
    fill: "#B3B3B3"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M198.869 95.1705C198.406 90.8204 198.631 86.4239 199.537 82.1436L198.869 95.1705Z",
    fill: "#B2B2B2"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M198.869 95.1705C198.406 90.8204 198.631 86.4239 199.537 82.1436",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M197.371 85.483C197.371 85.483 197.371 82.8093 200.376 74.4385L197.371 85.483Z",
    fill: "#B2B2B2"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M197.371 85.483C197.371 85.483 197.371 82.8093 200.376 74.4385",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M184.68 69.0664L190.848 76.0191L184.523 71.4327",
    fill: "#B2B2B2"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M184.68 69.0664L190.848 76.0191L184.523 71.4327",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M213.934 48.3474V57.2007L215.992 45.8193",
    fill: "#B2B2B2"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M213.934 48.3474V57.2007L215.992 45.8193",
    stroke: "#263238",
    strokeWidth: "0.572757px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M201.414 75.1702C201.39 75.2347 201.373 75.3004 201.361 75.3676C201.431 75.1702 201.455 75.0951 201.414 75.1702Z",
    fill: "#263238"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0727 56.0345V54.1507C10.0727 44.4404 22.3722 44.0324 22.3722 37.1253C22.3722 34.1214 19.932 32.1731 16.3067 32.1731C12.3256 32.1731 9.83314 34.3355 9.83314 37.4038V38.1742C9.83314 38.9379 9.41906 39.2876 8.64863 39.2876L1.18451 39.0091C0.485214 39.0091 0 38.6594 0 38.1742V37.4038C0 28.988 6.69368 23.1621 16.5335 23.1621C26.1593 23.1621 32.3738 28.6062 32.3738 36.7562C32.3738 48.3369 19.8797 48.4087 19.8797 54.7587V56.0144C19.9481 56.6003 19.5287 57.1305 18.9421 57.1989C18.8603 57.2083 18.7771 57.2083 18.6945 57.1989H11.2572C10.6714 57.266 10.1419 56.8452 10.0747 56.2594C10.066 56.1849 10.0653 56.1097 10.0727 56.0345ZM9.4251 67.2656C9.4251 64.1973 12.1438 61.6853 15.4195 61.6853C18.5589 61.6853 21.3555 64.1973 21.3555 67.2656C21.3555 70.3339 18.5589 72.8459 15.3544 72.8459C12.1854 72.9258 9.54657 70.4339 9.44389 67.2656H9.4251Z",
    fill: "#50529F"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M282.595 41.5865V40.0369C282.595 32.0581 292.692 31.7105 292.692 26.0295C292.692 23.5632 290.678 21.9505 287.696 21.9505C284.428 21.9505 282.363 23.7316 282.363 26.261V26.8932C282.363 27.5254 282.015 27.81 281.382 27.81L275.248 27.5777C274.668 27.5777 274.268 27.2932 274.268 26.8925V26.2604C274.268 19.3143 279.78 14.5508 287.874 14.5508C295.789 14.5508 300.901 19.0305 300.901 25.7443C300.901 35.2304 290.625 35.3251 290.625 40.5V41.5543C290.682 42.0342 290.338 42.4691 289.858 42.5254C289.787 42.5335 289.716 42.5335 289.645 42.5241H283.563C283.089 42.5845 282.657 42.2496 282.597 41.7758C282.589 41.7134 282.589 41.6496 282.595 41.5865ZM282.078 50.8305C281.891 48.1185 283.939 45.7689 286.651 45.5823C289.363 45.3958 291.712 47.4433 291.899 50.1553C292.086 52.8673 290.038 55.2168 287.326 55.4034C287.214 55.4108 287.102 55.4148 286.99 55.4148C284.372 55.5094 282.173 53.4639 282.079 50.8459C282.079 50.8412 282.078 50.8358 282.078 50.8305Z",
    fill: "#9FA2E2"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2586 127.32V126.11C60.2586 119.86 68.1757 119.584 68.1757 115.135C68.1757 113.23 66.6039 111.943 64.2598 111.943C61.6968 111.943 60.0774 113.334 60.0774 115.315V115.811C60.0774 116.306 59.8109 116.525 59.315 116.525L54.5514 116.344C54.1038 116.344 53.7891 116.125 53.7891 115.811V115.315C53.7891 109.875 58.105 106.141 64.4403 106.141C70.7756 106.141 74.5486 109.647 74.5486 114.905C74.5486 122.375 66.4979 122.422 66.4979 126.51V127.32C66.5429 127.696 66.2738 128.037 65.8979 128.082C65.8443 128.089 65.7899 128.089 65.7362 128.082H60.9726C60.5941 128.1 60.2727 127.808 60.2546 127.43C60.2532 127.393 60.2546 127.357 60.2586 127.32ZM59.8586 134.561C59.7432 132.46 61.3525 130.662 63.4544 130.546C65.5557 130.431 67.3536 132.04 67.469 134.142C67.5851 136.243 65.9751 138.041 63.8732 138.157C63.8054 138.161 63.7376 138.162 63.6692 138.163C61.6203 138.233 59.9022 136.629 59.8297 134.58L59.8586 134.561Z",
    fill: "#9FA2E2"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M247.166 82.3099V80.8865C247.166 73.5586 256.444 73.2398 256.444 68.0233C256.444 65.759 254.601 64.2805 251.856 64.2805C248.853 64.2805 246.954 65.916 246.954 68.2354V68.8172C246.954 69.395 246.64 69.6668 246.057 69.6668L240.42 69.4548C239.893 69.4548 239.523 69.1917 239.523 68.8259V68.2441C239.523 61.8719 244.583 57.4922 252.018 57.4922C259.29 57.4922 263.98 61.6041 263.98 67.7683C263.98 76.5196 254.545 76.5746 254.545 81.3623V82.3099C254.597 82.7529 254.281 83.1542 253.838 83.2065C253.775 83.2139 253.711 83.2139 253.648 83.2065H248.062C247.619 83.2589 247.218 82.9421 247.165 82.4998C247.159 82.4368 247.159 82.373 247.166 82.3099ZM246.691 90.8062C246.691 88.4868 248.747 86.5876 251.224 86.5876C253.598 86.5876 255.705 88.4868 255.705 90.8062C255.705 93.1256 253.581 95.0248 251.173 95.0248C248.764 95.0248 246.691 93.1175 246.691 90.7982V90.8062Z",
    fill: "#50529F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2307_11649",
    transform: "scale(0.0131579 0.0123457)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2307_11649",
    width: 76,
    height: 81,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABRCAYAAAB430BuAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAa1JREFUeNrs3MtuwjAQhWE8mtfL0+YBqViAUATFk9ieyzleVmz69Z+pUxXajee27/v9+LVt29qn1zYi/T7veI1QNrRGLBtaI5TtKKFsR4gFXtgsqJKFzcYqBbYCq8S1YhXU81ohxAIozAMq5U3fAyrts2QErBRgXlCfsMKDRcMKCxYRKiSYJ1QPViiwDFghwLyhLFjuYNmw3MAyQrmARYC6grUUrALW4ygK1KgjxAowktGhroylsiinkUTAGgaGgnV5h2WGOrvHhFUFulYQDLwu6MLO/tCFdU0EQ8fi0p95D6tal/U+xsJmjCR3Fwubt8MQ6rLsMeEociR9wFgXCxuyeoR1sbC1YKzLcA9Dx+q5j3Ekz47krLqu/vMH1NKvhvUCm1FXRqweB1lRVqXSZHRdFcdwWmH/YWWB/BWQsCyHwlCwhoBZsCrACsuy7TFZjZUdWVmVcSQ9dlBmdOn9BtDK+rbH9AhyfCH6CB4P/Nv/rFPFPyB6PksiLH9FLSXFG0y9dtnIkpUFAYOt2InpP7di9S8OZU1JC+utzPsqoiyqGBifZTvGMvIz5p8AAwBp+O3lVoQBUwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2307_11649",
    transform: "scale(0.0131579 0.0123457)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2307_11649",
    width: 76,
    height: 81,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABRCAYAAAB430BuAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAa1JREFUeNrs3MtuwjAQhWE8mtfL0+YBqViAUATFk9ieyzleVmz69Z+pUxXajee27/v9+LVt29qn1zYi/T7veI1QNrRGLBtaI5TtKKFsR4gFXtgsqJKFzcYqBbYCq8S1YhXU81ohxAIozAMq5U3fAyrts2QErBRgXlCfsMKDRcMKCxYRKiSYJ1QPViiwDFghwLyhLFjuYNmw3MAyQrmARYC6grUUrALW4ygK1KgjxAowktGhroylsiinkUTAGgaGgnV5h2WGOrvHhFUFulYQDLwu6MLO/tCFdU0EQ8fi0p95D6tal/U+xsJmjCR3Fwubt8MQ6rLsMeEociR9wFgXCxuyeoR1sbC1YKzLcA9Dx+q5j3Ekz47krLqu/vMH1NKvhvUCm1FXRqweB1lRVqXSZHRdFcdwWmH/YWWB/BWQsCyHwlCwhoBZsCrACsuy7TFZjZUdWVmVcSQ9dlBmdOn9BtDK+rbH9AhyfCH6CB4P/Nv/rFPFPyB6PksiLH9FLSXFG0y9dtnIkpUFAYOt2InpP7di9S8OZU1JC+utzPsqoiyqGBifZTvGMvIz5p8AAwBp+O3lVoQBUwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image0_2307_11649",
    width: 76,
    height: 81,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABRCAYAAAB430BuAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAa1JREFUeNrs3MtuwjAQhWE8mtfL0+YBqViAUATFk9ieyzleVmz69Z+pUxXajee27/v9+LVt29qn1zYi/T7veI1QNrRGLBtaI5TtKKFsR4gFXtgsqJKFzcYqBbYCq8S1YhXU81ohxAIozAMq5U3fAyrts2QErBRgXlCfsMKDRcMKCxYRKiSYJ1QPViiwDFghwLyhLFjuYNmw3MAyQrmARYC6grUUrALW4ygK1KgjxAowktGhroylsiinkUTAGgaGgnV5h2WGOrvHhFUFulYQDLwu6MLO/tCFdU0EQ8fi0p95D6tal/U+xsJmjCR3Fwubt8MQ6rLsMeEociR9wFgXCxuyeoR1sbC1YKzLcA9Dx+q5j3Ekz47krLqu/vMH1NKvhvUCm1FXRqweB1lRVqXSZHRdFcdwWmH/YWWB/BWQsCyHwlCwhoBZsCrACsuy7TFZjZUdWVmVcSQ9dlBmdOn9BtDK+rbH9AhyfCH6CB4P/Nv/rFPFPyB6PksiLH9FLSXFG0y9dtnIkpUFAYOt2InpP7di9S8OZU1JC+utzPsqoiyqGBifZTvGMvIz5p8AAwBp+O3lVoQBUwAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgexport2);
export default __webpack_public_path__ + "static/media/svgexport-2.e1b0e3d49cc6f404696676eeaf4ee106.svg";
export { ForwardRef as ReactComponent };